import * as React from "react";
import _ from "lodash";

import { Datetime } from "src/library/components/Datetime";
import { InfoBar } from "src/library/components/InfoBar";
import { formatCountTerminology } from "src/library/utils/string-manipulations/format-count-terminology";
import type { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import type { IUser } from "src/core/users/api/users.api";
import { IRole } from "src/core/shared/api/roles.api";

interface IProps {
  isLoading: boolean;
  data: IUser | null;
  role: IRole | null;
  primaryAction?: JSX.Element | null;
  secondaryAction?: JSX.Element | null;
  terminology: ITerminology;
}

const CustomerUserInfoSidebar = ({
  isLoading, data, primaryAction, secondaryAction, terminology, role
}: IProps) => {
  return (
    <InfoBar
      isLoading={isLoading}
      title={`${terminology.user.singular.text} information`}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      items={_.compact([
        {
          label: "Name",
          value: data ? `${data.firstName} ${data.lastName}` : "-"
        },
        {
          label: "Email",
          value: data ? data.email : "-"
        },
        {
          label: "Created On",
          value: data ? (
            <Datetime
              date={data.createdAt}
              template="long_date"
            />
          ) : "-"
        },
        role ?
          {
            label: "Role",
            value: role ? role.name : "-"
          } : null,
        {
          label: "Access to",
          value: data && data.userBranches && data.userBranches.length ? formatCountTerminology(data.userBranches.length, terminology.drop) : "-"
        }
      ])}
    />
  );
};

export default CustomerUserInfoSidebar;
